var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-bar",class:_vm.currentZoom === 100 ? 'colaborators-only' : ''},[(_vm.currentZoom !== 100)?_c('Description',{staticClass:"description"}):_vm._e(),_c('Microscope',{staticClass:"microscope"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }